var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/Interface/Search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3096 25.7429C19.8925 29.2807 13.4268 29.0022 9.33216 24.9076C4.93876 20.5142 4.93876 13.3911 9.33216 8.99769C13.7256 4.60429 20.8487 4.60429 25.2421 8.99769C29.3367 13.0923 29.6151 19.558 26.0774 23.9751L34.6701 32.5679C35.1583 33.056 35.1583 33.8475 34.6701 34.3356C34.182 34.8238 33.3905 34.8238 32.9024 34.3356L24.3096 25.7429ZM11.0999 23.1398C7.68284 19.7227 7.68284 14.1825 11.0999 10.7655C14.517 7.34836 20.0572 7.34837 23.4743 10.7655C26.8889 14.18 26.8914 19.7146 23.4818 23.1323C23.4793 23.1348 23.4768 23.1373 23.4743 23.1398C23.4718 23.1423 23.4693 23.1448 23.4668 23.1473C20.0491 26.5569 14.5145 26.5544 11.0999 23.1398Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.d4b28f83034e2517a2dceffba826d156.svg";
export { ForwardRef as ReactComponent };